import { render, staticRenderFns } from "./LeaveWasRequested.vue?vue&type=template&id=3be5b2b4"
import script from "./LeaveWasRequested.vue?vue&type=script&lang=js"
export * from "./LeaveWasRequested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports